const STORE_CHECKOUT_ASSETS = '/src/assets/store-checkout';
const STORE_REVIEW_SVG_ASSETS = '/src/assets/svg/store-review';

export const STORE_CHECKOUT_AI_ICON_SRC = `${STORE_REVIEW_SVG_ASSETS}/ai-icon.svg`;

export type StoreAiPreviewVibe = 'ai-flat-lay' | 'ai-model';

export const STORE_PROGRESSIVE_STYLE_GENERATE_DELAY_MS = 1800;
export const STORE_PROGRESSIVE_STYLE_REGENERATE_DELAY_MS = 1200;

export const STORE_CHECKOUT_AI_IMAGE_NO_MORE_REGENERATIONS_TOOLTIP =
  'No more regenerations left' as const;

export const STORE_CHECKOUT_AI_IMAGE_GENERATION_PLACEHOLDER_SRC = `${STORE_CHECKOUT_ASSETS}/ai-image-generation-placeholder.svg`;

export const STORE_PROGRESSIVE_STYLE_PREVIEW_DESIGN_SRC = `${STORE_CHECKOUT_ASSETS}/progressive-style-previews/design.png`;

export const STORE_DESIGN_YOUR_STORE_VIBES = [
  {
    id: 'default',
    controlName: 'vibeDefault',
    label: 'Default',
    description: 'Design + vibes. Just how we like it.',
    imageSrc: `${STORE_CHECKOUT_ASSETS}/design-your-store-vibes/default.png`,
  },
  {
    id: 'ai-flat-lay',
    controlName: 'vibeAiFlatLay',
    label: 'AI Flat Lay',
    description: 'Chill flat lay with good lighting vibes. AI-made.',
    imageSrc: `${STORE_CHECKOUT_ASSETS}/design-your-store-vibes/Ai flat lay.png`,
  },
  {
    id: 'ai-model',
    controlName: 'vibeAiModel',
    label: 'AI Model',
    description: 'Show the fit. We use AI to make the vibes.',
    imageSrc: `${STORE_CHECKOUT_ASSETS}/design-your-store-vibes/ai model.png`,
  },
] as const;

export const STORE_PROGRESSIVE_STYLE_PREVIEW_BY_VIBE: Readonly<
  Record<string, { front: string; back: string }>
> = {
  default: {
    front: `${STORE_CHECKOUT_ASSETS}/progressive-style-previews/default-front.png`,
    back: `${STORE_CHECKOUT_ASSETS}/progressive-style-previews/default-back.png`,
  },
  'ai-flat-lay': {
    front: `${STORE_CHECKOUT_ASSETS}/progressive-style-previews/flat-front.png`,
    back: `${STORE_CHECKOUT_ASSETS}/progressive-style-previews/flat-back.png`,
  },
  'ai-model': {
    front: `${STORE_CHECKOUT_ASSETS}/progressive-style-previews/model-front.png`,
    back: `${STORE_CHECKOUT_ASSETS}/progressive-style-previews/model-back.png`,
  },
};
